import { gql } from '@apollo/client';

import POST_FIELDS from './fragments/post';

const UPDATE_POST_DATE = gql`
  mutation updatePostDueAt($input: UpdatePostDueAtInput!) {
    updatePostDueAt(input: $input) {
      ... on PostUpdated {
        success
        message
        post {
          ...PostFields
        }
      }
      ... on PostNotUpdated {
        success
        message
      }

      ... on PostNotFound {
        success
        message
      }

      ... on CoreWebAppCommonError {
        success
        message
      }
    }
  }
  ${POST_FIELDS}
`;

export default UPDATE_POST_DATE;
